module.exports = new __parcel__URL__("NWBrickCon.2304f89c.avif").toString();